import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Grid,
  TextField,
  Button,
  Link,
  IconButton,
  Card,
  CardContent,
  Typography,
  Paper,
  Breadcrumbs,
} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import Header from "../common/Header";
import HeaderSec from "../common/HeaderSec";
import Footer from "../common/Footer";
import bgImage from "../../assets/breadcrumb-bg.webp";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import OfficeLocation from "./OfficeLocation";

const ContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [cartItems, setCartItems] = useState([]);

  // Load cart from session storage on initial render
  React.useEffect(() => {
    const storedCart = sessionStorage.getItem("cart");
    if (storedCart) {
      setCartItems(JSON.parse(storedCart));
    }
  }, []);
  return (
    <>
      <HeaderSec
        cartItems={cartItems}
        onCartUpdate={(updatedCart) => setCartItems(updatedCart)}
      />
      <Box
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          py: 8,
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: 2 }}>
            <Typography
              sx={{ fontSize: "35px", fontWeight: 600, color: "#27272f " }}
            >
              Contact Us
            </Typography>
          </Box>

          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
            sx={{ justifyContent: "center", display: "flex" }}
          >
            <Link
              href="/"
              component="a"
              sx={{
                display: "flex",
                alignItems: "center",
                color: "#b5651d",
                fontSize: "24px",
                textDecoration: "none", // optional: removes underline
              }}
            >
              Home
            </Link>
            <Typography sx={{ color: "#6fbe3d", fontSize: "24px" }}>
              Contact Us:
            </Typography>
          </Breadcrumbs>
        </Container>
      </Box>

      {/* Main Content */}
      <Container maxWidth="lg" sx={{ my: 6 }}>
        <Grid container spacing={4}>
          {/* Left Column - Contact Info */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                mb: 3,
                color: "#018f87",
                position: "relative",
                "&:after": {
                  content: '""',
                  position: "absolute",
                  width: "60px",
                  height: "4px",
                  backgroundColor: "#018f87",
                  bottom: "-10px",
                  left: 0,
                  borderRadius: "2px",
                },
              }}
            >
              Get in touch with us
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "#555",
                mb: 4,
                lineHeight: 1.8,
                fontSize: "1.1rem",
              }}
            >
              We're here to support your journey to 
              well-being. Reach out today to ask questions or schedule a
              consultation.
            </Typography>

            {/* Contact Cards */}
            <Grid container spacing={2} alignItems="stretch">
              {" "}
              {/* Added alignItems="stretch" */}
              <Grid item xs={12} sm={6}>
                <Card
                  sx={{
                    p: 3,
                    boxShadow: "0 4px 20px rgba(0, 94, 176, 0.1)",
                    borderLeft: "4px solid #018f87",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <Box
                      sx={{
                        backgroundColor: "#e0f7ff",
                        color: "#018f87",
                        borderRadius: "50%",
                        p: 1.5,
                        mr: 2,
                      }}
                    >
                      <PhoneIcon />
                    </Box>
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      Contact Us
                    </Typography>
                  </Box>
                  <Typography>+91 63645 61442</Typography>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Card
                  sx={{
                    p: 3,
                    boxShadow: "0 4px 20px rgba(0, 94, 176, 0.1)",
                    borderLeft: "4px solid #018f87",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <Box
                      sx={{
                        backgroundColor: "#e0f7ff",
                        color: "#018f87",
                        borderRadius: "50%",
                        p: 1.5,
                        mr: 2,
                      }}
                    >
                      <EmailIcon />
                    </Box>
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      Email Us
                    </Typography>
                  </Box>
                  <Typography>navakarnatakanirmanawelfaretrust@gmail.com</Typography>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Card
                  sx={{
                    height: 130,
                    p: 3,
                    boxShadow: "0 4px 20px rgba(0, 94, 176, 0.1)",
                    borderLeft: "4px solid #018f87",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <Box
                      sx={{
                        backgroundColor: "#e0f7ff",
                        color: "#018f87",
                        borderRadius: "50%",
                        p: 1.5,
                        mr: 2,
                      }}
                    >
                      <LocationOnIcon />
                    </Box>
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      Location
                    </Typography>
                  </Box>
                  <Typography variant="body2">
                  KALPAVRUKSHA GREEN, 6P8R+V72, SH 104, Channahalli, Srothreyathellohalli, Karnataka 562165
                  </Typography>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Card
                  sx={{
                    height: 130,
                    p: 3,
                    boxShadow: "0 4px 20px rgba(0, 94, 176, 0.1)",
                    borderLeft: "4px solid #018f87",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <Box
                      sx={{
                        backgroundColor: "#e0f7ff",
                        color: "#018f87",
                        borderRadius: "50%",
                        p: 1.5,
                        mr: 2,
                      }}
                    >
                      <AccessTimeIcon />
                    </Box>
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      Open Hours
                    </Typography>
                  </Box>
                  <Typography>Mon-Sat (09:00 AM-07:00 PM)</Typography>
                </Card>
              </Grid>
            </Grid>

          </Grid>

          {/* Right Column - Contact Form */}
          <Grid item xs={12} md={6}>
            <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  mb: 3,
                  color: "#018f87",
                }}
              >
                Send us a message
              </Typography>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="First Name"
                    variant="outlined"
                    size="medium"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Last Name"
                    variant="outlined"
                    size="medium"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Email"
                    variant="outlined"
                    size="medium"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Phone"
                    variant="outlined"
                    size="medium"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Your Message"
                    variant="outlined"
                    multiline
                    rows={4}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    fullWidth
                    variant="contained"
                    size="large"
                    sx={{
                      backgroundColor: "#018f87",
                      "&:hover": { backgroundColor: "#004a8c" },
                      py: 1.5,
                      fontSize: "1.1rem",
                      fontWeight: 600,
                    }}
                  >
                    Send Message
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Container>

      {/* Google Map */}
      <OfficeLocation />

      {/* Call to Action */}
      <Box
        sx={{
          background:"linear-gradient(to right, rgba(226, 255, 255, 0.26), rgba(0, 180, 194, 0.16))",
          color: "#fff",
          py: 4,
          textAlign: "center",
        }}
      >
        <Container>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item xs={12} md={6} sx={{ mb: { xs: 3, md: 0 } }}>
              <Typography
                variant="h5"
                sx={{ fontWeight: 600, color: "#018f87" }}
              >
                Ready to start your wellness journey?
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", md: "flex-end" },
                }}
              >
                <Button
                  variant="contained"
                  size="medium"
                  sx={{
                    backgroundColor: "#018f87",
                    "&:hover": { backgroundColor: "#11b9a0ff" },
                    px: 4,
                    py: 1,
                    fontSize: "1rem",
                    fontWeight: 600,
                    mr: 2,
                  }}
                >
                  Book Consultation
                </Button>
                <Button
                  variant="outlined"
                  size="medium"
                  sx={{
                    borderColor: "#b5651d",
                    color: "#018f87",
                    px: 4,
                    py: 1,
                    fontSize: "1rem",
                    fontWeight: 600,
                  }}
                >
                  Call Now
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Footer />
    </>
  );
};

export default ContactUs;
